<form #groupForm="ngForm" class="form-horizontal" (ngSubmit)="!saving && groupForm.valid && save()">
    <div class="mon-dialog-header">
        <page-header panelClass="row"
                     [header]="title"
                     panelLeftClass="col-48 pt-2">
        </page-header>
    </div>

    <div class="mon-dialog-body-with-footer group-form-container">
        <div class="row mt-3">
            <div class="col-48 px-12">
                <div class="card panel-monsido-card">
                    <div class="card-header">
                        <h3 class="font-weight-300" translate>Details</h3>
                    </div>
                    <div class="card-body">
                        <form-field-input [required]="true"
                                          name="group_name"
                                          [(ngModel)]="domainGroup.title"
                                          label="{{ 'Name' | translate }}"
                                          placeholder="{{ 'Group name' | translate }}"
                                          type="text">
                        </form-field-input>
                    </div>
                </div>
            </div>
        </div>

        <div class="row mt-3">
            <div class="col-48 px-12">
                <div class="card panel-monsido-card">
                    <div class="card-header">
                        <h3 class="font-weight-300" translate>Rules</h3>
                    </div>
                    <div class="card-body">
                        <form-domain-groups-rules [(domainGroup)]="domainGroup">
                        </form-domain-groups-rules>
                    </div>
                </div>
            </div>
        </div>

        <div class="row mt-3">
            <div class="col-48 px-12">
                <div class="card panel-monsido-card">
                    <div class="card-header">
                        <h3 class="font-weight-300" translate>Users</h3>
                    </div>
                    <div class="card-body">
                        <form-domain-groups-users [domainGroup]="domainGroup">
                        </form-domain-groups-users>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="mon-dialog-footer text-right">
        <button type="submit"
                data-test="save-button"
                class="btn btn-border-radius btn-secondary"
                [disabled]="groupForm.invalid || !isDomainGroupComplete || saving" translate>
            Save
        </button>
    </div>
</form>
